import NewsletterCard from './newsletter-card'

export default NewsletterCard
